import type { Guide } from '../types';

/** S-21.10-01 — działy przyjęcia zleceń i pulpit z kolejkami (scenariusz e2e 16, ścieżka MIX-01/MIX-05). */
export const guide: Guide = {
  flagKey: 'intakeDepartments',
  title: 'Działy przyjęcia zleceń: CS i Administracja',
  whatItDoes:
    'Przyjęcie zleceń dzieli się na dwa działy: CS tworzy i uzupełnia prezlecenia, Administracja je kontroluje i zapisuje do VIA plikiem. Każdy dział ma pulpit z kolejkami, a każda liczba na pulpicie otwiera listę prezleceń z tym samym filtrem. Role „CS” i „Administracja” nadaje administrator w kontach użytkowników; dotychczasowe konta przyjęcia zleceń pracują w obu działach.',
  audience: ['CS', 'Administracja', 'administrator'],
  presentationItems: ['S-21.10-01'],
  steps: [
    {
      route: '/intake-dashboard',
      target: 'intake-dashboard-administration',
      mockupTestId: 'wsp-dzial-adm',
      title: 'Pulpit Administracji',
      description:
        'Kolejki Administracji: do kontroli, zatwierdzone przed plikiem, błąd zapisu, plik czeka na TMS i zmiany do wprowadzenia w TMS. Administracja zaczyna pracę od tego ekranu.',
      action: 'Otwórz „Pulpit przyjęcia zleceń” w menu.',
      recorder: { account: 'adm' },
    },
    {
      route: '/intake-dashboard',
      target: 'intake-tile-adm_control',
      title: 'Kafelek prowadzi do listy',
      description:
        'Liczba na kafelku to liczba prezleceń na liście, którą kafelek otwiera — ten sam filtr. „Do kontroli” to prezlecenia przekazane przez CS.',
      action: 'Kliknij kafelek „Do kontroli”.',
      recorder: { account: 'adm' },
    },
    {
      route: '/pre-orders',
      target: 'pre-order-intake',
      title: 'Dział i etap na liście prezleceń',
      description:
        'W kolumnie „Obieg” widać, u którego działu jest prezlecenie i na jakim etapie; filtr „Kolejka działu” ustawia kafelek pulpitu.',
      action: 'Na liście prezleceń sprawdź kolumnę „Obieg” albo wybierz „Kolejka działu”.',
      recorder: { account: 'adm' },
    },
    {
      route: '/intake-dashboard',
      target: 'intake-dashboard-cs',
      mockupTestId: 'wsp-dzial-cs',
      title: 'Pulpit CS',
      description:
        'Kolejki CS: do uzupełnienia, zwrócone z pytaniem, uwagi od FTL i zmiany zleceń czekające na decyzję. Konto z rolą CS widzi tylko swoją część pulpitu.',
      action: 'Jako CS otwórz „Pulpit przyjęcia zleceń” w menu.',
      recorder: { account: 'cs' },
    },
  ],
};
